export default __webpack_public_path__ + "static/media/786.76a4c166.png";